// extracted by mini-css-extract-plugin
module.exports = {"CardsContainer":"Cards_CardsContainer__2m3X0"};